import { render, staticRenderFns } from "./userCoupon.vue?vue&type=template&id=5ca1082e&scoped=true&"
import script from "./userCoupon.vue?vue&type=script&lang=js&"
export * from "./userCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca1082e",
  null
  
)

export default component.exports